import deserialize from 'app/utils/deserialize'
import FormErrors from 'app/utils/form_errors'
import { fetch, update } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    item: null
  },

  mutations: {
    accountReferrersFetched(state, { accountReferrers }) {
      state.item = accountReferrers
    },

    resetState(state) {
      state.item = null
    }
  },

  getters: {
    accountReferrers(state) {
      return state.item
    }
  },

  actions: {
    async fetchAccountReferrers({ commit }) {
      const response = await fetch({
        url: '/api/account/referrers',
        type: 'account-referrers'
      })

      const accountReferrers = await deserialize(response.data)

      commit('accountReferrersFetched', { accountReferrers })

      return accountReferrers
    },

    async updateHostnames({ commit, state }, { hostnames }) {
      try {
        const response = await update({
          url: '/api/account/referrers',
          type: 'account-referrers',
          changes: { hostnames },
          record: state.item
        })

        const accountReferrers = await deserialize(response.data)

        commit('accountReferrersFetched', { accountReferrers })

        return accountReferrers
      } catch (error) {
        throw new FormErrors(error.response.data.errors)
      }
    }
  }
}
